import React, { useMemo } from 'react';
import {
  FullScreenModal,
  FullScreenModalBackButton,
  FullScreenModalBody,
  FullScreenModalContent,
  FullScreenModalHeader,
  FullScreenModalTitle,
} from './ui/fullscreen-modal';
import { Badge } from './ui/badge';
import { cn } from '../lib/utils';

const SERIES = [
  { id: 'vibrent', label: 'Vibrent', count: 27 },
  { id: 'upstream', label: 'Upstream', count: 22 },
  { id: 'teams', label: 'Teams', count: 9 },
  { id: 'toon', label: 'Toon', count: 10 },
  { id: 'memo', label: 'Memo', count: 35 },
  { id: 'notion', label: 'Notion', count: 15 },
  { id: 'bluey', label: 'Bluey', count: 10 },
  { id: '3d', label: '3D', count: 5 },
];

const buildUrl = (seriesId, idx) =>
  `https://raw.githubusercontent.com/alohe/avatars/main/png/${seriesId}_${idx}.png`;

const AvatarPickerModal = ({
  open,
  onOpenChange,
  title = 'Выберите аватар',
  selectedUrl,
  onSelect,
}) => {
  const avatars = useMemo(() => {
    const list = [];
    for (const s of SERIES) {
      for (let i = 1; i <= s.count; i += 1) {
        list.push({
          id: `${s.id}_${i}`,
          series: s.id,
          label: `${s.label} ${i}`,
          url: buildUrl(s.id, i),
        });
      }
    }
    return list;
  }, []);

  return (
    <FullScreenModal open={open} onOpenChange={onOpenChange}>
      <FullScreenModalContent className="flex flex-col">
        <FullScreenModalHeader>
          <FullScreenModalBackButton onClick={() => onOpenChange(false)} />
          <FullScreenModalTitle>{title}</FullScreenModalTitle>
          <div className="w-10" />
        </FullScreenModalHeader>

        <FullScreenModalBody>
          <div className="space-y-4">
            <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-3">
              {avatars.map((a) => {
                const isSelected = !!selectedUrl && a.url === selectedUrl;
                return (
                  <button
                    key={a.id}
                    type="button"
                    className={cn(
                      'relative rounded-xl border bg-white overflow-hidden aspect-square hover:shadow-sm transition-shadow',
                      isSelected ? 'border-primary ring-2 ring-primary/30' : 'border-border'
                    )}
                    onClick={() => {
                      onSelect?.(a.url);
                      onOpenChange(false);
                    }}
                    title={a.id}
                  >
                    <img
                      src={a.url}
                      alt={a.id}
                      loading="lazy"
                      className="w-full h-full object-cover"
                    />
                    {isSelected && (
                      <div className="absolute top-1 right-1">
                        <Badge className="text-[10px] px-2 py-0.5">Выбрано</Badge>
                      </div>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </FullScreenModalBody>
      </FullScreenModalContent>
    </FullScreenModal>
  );
};

export default AvatarPickerModal;

